module.exports = __webpack_public_path__ + "img/A.e02c0379.png";